<template>
  <BaseKanbanView
    :target="EntityTargetTypes.TASKS"
    :loading="tasksLoading"
    dataGetterPath="tasks/currentTasks"
    groupedDataGetter="tasks/groupedTasks"
    columnsGetter="tasks/tableColumns"
    :extraFilters="getExtraFilters()"
  >
    <template #default="{ data, groupBy }">
      <div
        v-if="selectedField.options.length !== 0"
        class="max-w-max grid grid-flow-col gap-6"
      >
        <TaskKanbanColumn
          v-for="(option, index) of selectedField.options"
          :key="`${selectedField.name}_${option.label}`"
          :selectedField="selectedField"
          :data="data"
          :groupBy="groupBy"
          :option="option"
          :index="index"
          @edit-columns="onEditColumns"
        />

        <div
          v-if="canEditColumns"
          class="flex items-center p-3 col-span-1 w-60 lg:w-80 h-[46px] px-4 py-2 rounded-lg bg-white border border-gray-300 text-sm text-gray-400 cursor-pointer mr-6 group"
          :class="{
            'mt-8': can(actions.CREATE_TASKS)
          }"
          @click="onEditColumns"
        >
          <span class="opacity-80 group-hover:opacity-100">
            <i class="fa-solid fa-objects-column mr-1" aria-hidden="true" />
            {{ $t('Add / remove columns') }}
          </span>
        </div>
      </div>
    </template>
    <template #after>
      <TaskStatusesDialog
        v-if="showEditStatuses"
        v-model="showEditStatuses"
      />

      <CustomFieldDialog
        v-if="showEditCustomField"
        v-model="showEditCustomField"
        :customField="customField"
        @save="showEditCustomField = false"
        @close="showEditCustomField = false"
      />
    </template>
  </BaseKanbanView>
</template>
<script lang="ts" setup>
import { ref, computed } from "vue";

import TaskKanbanColumn from "@/modules/tasks/components/TaskKanbanColumn.vue";
import TaskStatusesDialog from "@/modules/accounts/components/TaskStatusesDialog.vue";
import CustomFieldDialog from "@/modules/accounts/components/CustomFieldDialog.vue";

// Utils
import { EntityTargetTypes } from '@/modules/common/utils/filterUtils'
import { getExtraFilters } from "@/modules/tasks/utils/taskTableUtils"

import { useKanbanGroups } from "@/modules/projects/composables/useKanbanGroups.js";
import { useStore } from "vuex";
import useCan from "@/modules/common/composables/useCan.js";

const { selectedField } = useKanbanGroups({
  entity: 'task'
})

const {
  can,
  actions
} = useCan()

const store = useStore()

const canEditColumns = computed(() => {
  if (customField.value) {
    return selectedField.value?.isProjectScoped
      ? can(actions.EDIT_CUSTOM_FIELDS_INSIDE_PROJECTS)
      : can(actions.EDIT_CUSTOM_FIELDS)
  }

  return can(actions.EDIT_TASK_STATUSES)
})

const customFields = computed(() => {
  return store.getters["accounts/tableColumnCustomFields"]('task') || []
})

const tasksLoading = computed(() => {
  return store.state.tasks.tasksLoading
})

const customField = computed(() =>{
  if (!selectedField.value?.groupByProp?.includes('custom_fields')) {
    return
  }

  const customFieldId = selectedField.value.options?.[0]?.prop?.split('_')[1]
  return customFields.value.find((field: any) => {
    return field.id == customFieldId
  })
})

const showEditStatuses = ref(false)
const showEditCustomField = ref(false)

function onEditColumns() {
  if (customField.value) {
    showEditCustomField.value = true
    return
  }

  showEditStatuses.value = true 
}
</script>
